import { render, staticRenderFns } from "./StoresPhotoUploader.vue?vue&type=template&id=7a8693a8"
import script from "./StoresPhotoUploader.vue?vue&type=script&lang=js"
export * from "./StoresPhotoUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports